(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-resenas-carrusel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tag = 'orion-reviews-carousel';
    if (customElements.get(tag)) return;

    class OrionReviewsCarousel extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this.stage = this.querySelector('[data-orion-stage]');
        this.track = this.querySelector('[data-orion-track]');
        this.prev = this.querySelector('[data-orion-prev]');
        this.next = this.querySelector('[data-orion-next]');
        this.currentLabel = this.querySelector('[data-orion-current]');
        this.totalLabel = this.querySelector('[data-orion-total]');
        if (!this.stage || !this.track) return;

        this.originals = [...this.track.querySelectorAll('[data-orion-slide]:not([data-orion-clone])')];
        this.count = this.originals.length;
        if (!this.count) return;
        this.cloneCount = 3; // 2 vistas laterales + 1 de margen para un bucle sin saltos.
        this.isAnimating = false;
        this._hovered = false;
        this._focused = false;
        this._swipeTime = 0;
        this._pointer = null;
        this._timer = null;
        this._fallback = null;
        this._autoplay = this.dataset.autoplay === 'true';
        this._interval = Math.max(4000, Number(this.dataset.interval) || 8000);
        this._reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this._editing = Boolean(window.Shopify && window.Shopify.designMode);
        this.classList.add('is-initializing');

        // Copias a ambos extremos para que el carrusel sea infinito incluso con pocas reseñas.
        const first = this.originals[0];
        for (let offset = this.cloneCount; offset >= 1; offset--) {
          const source = this.originals[((this.count - offset) % this.count + this.count) % this.count];
          this.track.insertBefore(this.makeClone(source), first);
        }
        for (let offset = 0; offset < this.cloneCount; offset++) {
          this.track.appendChild(this.makeClone(this.originals[offset % this.count]));
        }
        this.slides = [...this.track.querySelectorAll('[data-orion-slide]')];
        this.index = this.cloneCount;
        this._ready = true;

        this._clickPrev = () => this.go(-1, true);
        this._clickNext = () => this.go(1, true);
        this._transitionEnd = (e) => { if (e.target === this.track && e.propertyName === 'transform') this.finish(); };
        this._handlePointerDown = (e) => this.pointerDown(e);
        this._handlePointerMove = (e) => this.pointerMove(e);
        this._handlePointerUp = (e) => this.pointerUp(e);
        this._handlePointerCancel = () => this.pointerCancel();
        this._handleClick = (e) => this.handleClick(e);
        this._handleKeyDown = (e) => this.handleKeyDown(e);
        this._handleResize = () => this.align(false);
        this._handleVisibility = () => { if (document.hidden) this.slides.forEach(slide => { const video = slide.querySelector('video'); if (video) video.pause(); }); else this.syncVideo(); this.armTimer(); };
        this._handleBlockSelect = (e) => this.handleBlockSelect(e);
        this._handleMouseEnter = (e) => { if (e.pointerType === 'mouse') { this._hovered = true; this.armTimer(); } };
        this._handleMouseLeave = (e) => { if (e.pointerType === 'mouse') { this._hovered = false; this.armTimer(); } };
        this._handleFocusIn = () => { this._focused = true; this.armTimer(); };
        this._handleFocusOut = (e) => {
          if (!this.contains(e.relatedTarget)) { this._focused = false; this.armTimer(); }
        };

        this.prev.addEventListener('click', this._clickPrev);
        this.next.addEventListener('click', this._clickNext);
        this.track.addEventListener('transitionend', this._transitionEnd);
        this.stage.addEventListener('pointerdown', this._handlePointerDown);
        this.stage.addEventListener('pointermove', this._handlePointerMove);
        this.stage.addEventListener('pointerup', this._handlePointerUp);
        this.stage.addEventListener('pointercancel', this._handlePointerCancel);
        this.stage.addEventListener('click', this._handleClick);
        this.addEventListener('keydown', this._handleKeyDown);
        this.addEventListener('pointerenter', this._handleMouseEnter);
        this.addEventListener('pointerleave', this._handleMouseLeave);
        this.addEventListener('focusin', this._handleFocusIn);
        this.addEventListener('focusout', this._handleFocusOut);
        document.addEventListener('visibilitychange', this._handleVisibility);
        document.addEventListener('shopify:block:select', this._handleBlockSelect);
        if ('ResizeObserver' in window) {
          this._resizer = new ResizeObserver(this._handleResize);
          this._resizer.observe(this.stage);
        } else {
          window.addEventListener('resize', this._handleResize);
        }

        this.applyState();
        this.align(false);
        this.classList.remove('is-initializing');
        this.syncVideo();
        this.armTimer();
      }

      makeClone(source) {
        const clone = source.cloneNode(true);
        clone.setAttribute('data-orion-clone', '');
        clone.removeAttribute('data-shopify-editor-block');
        clone.removeAttribute('data-shopify-editor-block-id');
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      }

      getX(index) {
        const slide = this.slides[index];
        if (!slide) return 0;
        return this.stage.clientWidth / 2 - (slide.offsetLeft + slide.offsetWidth / 2);
      }

      align(animated = true) {
        if (!this._ready) return;
        if (!animated) this.track.style.transition = 'none';
        this.track.style.transform = `translate3d(${this.getX(this.index)}px,0,0)`;
        if (!animated) {
          void this.track.offsetWidth;
          this.track.style.transition = '';
        }
      }

      applyState() {
        this.slides.forEach((slide, i) => {
          const distance = Math.abs(i - this.index);
          slide.classList.toggle('is-active', distance === 0);
          slide.classList.toggle('is-near', distance === 1);
          slide.classList.toggle('is-far', distance === 2);
          slide.setAttribute('aria-hidden', distance === 0 ? 'false' : 'true');
          const soundButton = slide.querySelector('[data-orion-sound]');
          if (soundButton) soundButton.tabIndex = distance === 0 ? 0 : -1;
        });
        const number = ((this.index - this.cloneCount) % this.count + this.count) % this.count + 1;
        this.currentLabel.textContent = String(number).padStart(2, '0');
        this.totalLabel.textContent = String(this.count).padStart(2, '0');
      }

      syncVideo() {
        this.slides.forEach((slide, i) => {
          const video = slide.querySelector('video');
          if (!video) return;
          const soundButton = slide.querySelector('[data-orion-sound]');
          if (i === this.index && !document.hidden && !this._reduced) {
            video.muted = true;
            if (soundButton) {
              soundButton.classList.remove('is-unmuted');
              soundButton.setAttribute('aria-pressed', 'false');
              soundButton.setAttribute('aria-label', 'Activar sonido del vídeo');
            }
            const promise = video.play();
            if (promise && typeof promise.catch === 'function') promise.catch(() => {});
          } else {
            video.pause();
            video.muted = true;
            if (soundButton) {
              soundButton.classList.remove('is-unmuted');
              soundButton.setAttribute('aria-pressed', 'false');
              soundButton.setAttribute('aria-label', 'Activar sonido del vídeo');
            }
          }
        });
      }

      go(step, byUser = false) {
        if (!this._ready || this.isAnimating || !step) return;
        const boundedStep = Math.max(-2, Math.min(2, step));
        this.isAnimating = true;
        this.index += boundedStep;
        this.applyState();
        this.align(true);
        this.syncVideo();
        clearTimeout(this._fallback);
        this._fallback = setTimeout(() => this.finish(), 800);
        if (byUser) this.armTimer();
      }

      finish() {
        if (!this.isAnimating) return;
        clearTimeout(this._fallback);
        this.isAnimating = false;
        if (this.index < this.cloneCount || this.index >= this.cloneCount + this.count) {
          this.classList.add('is-teleporting');
          while (this.index < this.cloneCount) this.index += this.count;
          while (this.index >= this.cloneCount + this.count) this.index -= this.count;
          this.applyState();
          this.align(false);
          this.syncVideo();
          requestAnimationFrame(() => this.classList.remove('is-teleporting'));
        }
      }

      handleClick(e) {
        const soundButton = e.target.closest('[data-orion-sound]');
        if (soundButton) {
          e.stopPropagation();
          const slide = soundButton.closest('[data-orion-slide]');
          if (!slide || !slide.classList.contains('is-active')) return;
          const video = slide.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          soundButton.classList.toggle('is-unmuted', !video.muted);
          soundButton.setAttribute('aria-pressed', String(!video.muted));
          soundButton.setAttribute('aria-label', video.muted ? 'Activar sonido del vídeo' : 'Silenciar vídeo');
          if (video.paused) {
            const promise = video.play();
            if (promise && typeof promise.catch === 'function') promise.catch(() => {});
          }
          return;
        }
        if (Date.now() - this._swipeTime < 360) return;
        const slide = e.target.closest('[data-orion-slide]');
        if (!slide) return;
        const index = this.slides.indexOf(slide);
        const distance = index - this.index;
        if (Math.abs(distance) <= 2 && distance !== 0) this.go(distance, true);
      }

      handleKeyDown(e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1, true); }
      }

      pointerDown(e) {
        if (this.isAnimating || (e.pointerType === 'mouse' && e.button !== 0) || e.target.closest('button')) return;
        this._pointer = { id: e.pointerId, x: e.clientX, y: e.clientY, lastX: e.clientX, active: false, vertical: false };
      }

      pointerMove(e) {
        const p = this._pointer;
        if (!p || p.id !== e.pointerId || p.vertical) return;
        const dx = e.clientX - p.x;
        const dy = e.clientY - p.y;
        if (!p.active) {
          if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { p.vertical = true; return; }
          if (Math.abs(dx) < 9 || Math.abs(dx) < Math.abs(dy)) return;
          p.active = true;
          if (this.stage.setPointerCapture) {
            try { this.stage.setPointerCapture(e.pointerId); } catch (_) {}
          }
          clearInterval(this._timer);
          this._timer = null;
        }
        p.lastX = e.clientX;
        const limited = Math.max(-this.slides[this.index].offsetWidth, Math.min(this.slides[this.index].offsetWidth, dx));
        this.track.style.transition = 'none';
        this.track.style.transform = `translate3d(${this.getX(this.index) + limited}px,0,0)`;
        if (e.cancelable) e.preventDefault();
      }

      pointerUp(e) {
        const p = this._pointer;
        if (!p || p.id !== e.pointerId) return;
        this._pointer = null;
        if (this.stage.hasPointerCapture && this.stage.hasPointerCapture(e.pointerId)) {
          try { this.stage.releasePointerCapture(e.pointerId); } catch (_) {}
        }
        if (!p.active) return;
        this._swipeTime = Date.now();
        const dx = e.clientX - p.x;
        this.track.style.transition = '';
        if (Math.abs(dx) >= 32) this.go(dx < 0 ? 1 : -1, true);
        else { this.align(true); this.armTimer(); }
      }

      pointerCancel() {
        if (!this._pointer) return;
        this._pointer = null;
        this.track.style.transition = '';
        this.align(true);
        this.armTimer();
      }

      handleBlockSelect(e) {
        if (!this.contains(e.target) || !e.detail || !e.detail.blockId) return;
        const selected = this.originals.findIndex(slide => slide.dataset.reviewBlockId === e.detail.blockId);
        if (selected < 0) return;
        clearInterval(this._timer);
        this._timer = null;
        clearTimeout(this._fallback);
        this.isAnimating = false;
        this.index = this.cloneCount + selected;
        this.applyState();
        this.align(false);
        this.syncVideo();
      }

      armTimer() {
        clearInterval(this._timer);
        this._timer = null;
        if (!this._autoplay || this._editing || this._reduced || document.hidden || this._hovered || this._focused || this._pointer) return;
        this._timer = setInterval(() => this.go(1), this._interval);
      }

      disconnectedCallback() {
        if (!this._ready) return;
        clearInterval(this._timer);
        clearTimeout(this._fallback);
        this.slides.forEach(slide => { const video = slide.querySelector('video'); if (video) video.pause(); });
        this.prev.removeEventListener('click', this._clickPrev);
        this.next.removeEventListener('click', this._clickNext);
        this.track.removeEventListener('transitionend', this._transitionEnd);
        this.stage.removeEventListener('pointerdown', this._handlePointerDown);
        this.stage.removeEventListener('pointermove', this._handlePointerMove);
        this.stage.removeEventListener('pointerup', this._handlePointerUp);
        this.stage.removeEventListener('pointercancel', this._handlePointerCancel);
        this.stage.removeEventListener('click', this._handleClick);
        this.removeEventListener('keydown', this._handleKeyDown);
        this.removeEventListener('pointerenter', this._handleMouseEnter);
        this.removeEventListener('pointerleave', this._handleMouseLeave);
        this.removeEventListener('focusin', this._handleFocusIn);
        this.removeEventListener('focusout', this._handleFocusOut);
        document.removeEventListener('visibilitychange', this._handleVisibility);
        document.removeEventListener('shopify:block:select', this._handleBlockSelect);
        if (this._resizer) this._resizer.disconnect();
        else window.removeEventListener('resize', this._handleResize);
        this._ready = false;
      }
    }
    customElements.define(tag, OrionReviewsCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
